import React from 'react';
import { AiOutlineLink } from 'react-icons/ai';
import BaseBlock from '../BaseBlock';
import { modalNames } from '../../../../config';
import { useLinkClickHandler } from '../../../../hooks/useLinkClickHandler';
import styles from './index.module.scss';

const initialData = {
  url: '',
  text: '',
  editMode: false,
};

const LinkBlock = () => {
  const handleClick = useLinkClickHandler({
    initialData,
    modalName: modalNames.link,
  });

  return (
    <BaseBlock
      tooltipTitle="Вставить ссылку"
      onClick={handleClick}
    >
      <AiOutlineLink className={styles.icon} />
    </BaseBlock>
  );
};

export default LinkBlock;
